module.exports = __webpack_public_path__ + "static/media/line_cacao.78f7fdc6.jpg";